import * as React from "react";

const LinkFileInactive: React.FC = () => {
    return (
        <svg
            width="12px"
            height="16px"
            viewBox="0 0 12 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M10.5,14.5 L10.5,5 L7,5 L7,1.5 L1.5,1.5 L1.5,14.5 L10.5,14.5 Z M1.5,0 L8,0 L12,4 L12,14.5 L12,16 L10.5,16 L1.5,16 L0,16 L0,14.5 L0,1.5 L0,0 L1.5,0 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(LinkFileInactive);


